
import Vue from "vue";
import { mapFields } from "vuex-map-fields";
import { AnmaldArbete } from "@/store/types";
import { AnmaldArbeteText } from "@/store/map";
import SammanstallningField from "@/components/Kontaktuppgifter/SammanstallningField.vue";

export default Vue.extend({
    name: "AnstalldSammanstallning",
    components: {
        SammanstallningField,
    },
    data: () => ({
        AnmaldArbete,
        AnmaldArbeteText,
    }),
    computed: {
        ...mapFields([
            "observationer.vadStammerInPaPersonen",
            "observationer.anmaldArbete",
            "observationer.anmaldArbeteAdress",
            "observationer.anmaldHurVetDu",
            "observationer.anmaldHurOftaArbetar",
            "observationer.anmaldBeskrivArbete",
            "observationer.anmaldForetagIntressenter",
            "observationer.anmaldBeskrivForetag",
            "observationer.anmaldInsynIVerksamheten",
        ]),
    },
});
